import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

export const FAQSection = ({ items = FAQS, title = "Frequently asked" }) => (
  <section className="bg-[var(--bg)]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20">
        <div className="md:col-span-4">
          <div className="eyebrow">FAQ</div>
          <h2 className="section-title text-[44px] md:text-[58px] mt-4 leading-[1.02]">
            {title}
          </h2>
          <p className="mt-5 text-[15px] text-[var(--text-muted)] max-w-sm leading-relaxed">
            A short answer to the questions we hear most often. If you don&apos;t
            see yours, the leasing team is one call away.
          </p>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem
                value={`faq-${i}`}
                key={i}
                data-testid={TESTIDS.faqItem(i)}
                className="border-b border-[var(--border)]"
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline">
                  <span className="font-serif text-[22px] md:text-[26px] leading-tight tracking-tight pr-6">
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[var(--text-muted)] max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  </section>
);

export default FAQSection;
